// extracted by mini-css-extract-plugin
export default {"page":"GiftBrandManagement_page__ZR1zI"};